export default __webpack_public_path__ + "static/media/sites-mob1.173a8700.png";